import React from 'react'
import SeoMeta from '../Common/SeoMeta'
import { getImages } from '../Common/const'
import { Link } from 'react-router-dom'

const Mercedes2015BenzSlk350ForSaleInBoerneTexas = () => {
    return (
        <>
            <SeoMeta
                title="Used 2015 Mercedes-Benz SLK350 For Sale In Boerne & Austin, Texas at Mark Motors"
                description="The used 2015 Mercedes-Benz SLK350 for sale in Boerne & Austin, Texas is the second of three exceptional models in its class - the used 2015 Mercedes-Benz SLK250, SLK350 and SLK55 AMG."
                keywords="2015 Mercedes-Benz SLK350 For Sale in Boerne & Austin, Texas | 2015 Mercedes-Benz SLK350 Specials in Boerne & Austin, Texas | 2015 Mercedes-Benz SLK350 Dealer in Boerne & Austin, Texas | 2015 Mercedes-Benz SLK350 For Sale Near Boerne & Austin, Texas | 2015 Mercedes-Benz SLK350 in Boerne, TX"
                ogTitle="Used 2015 Mercedes-Benz SLK350 For Sale In Boerne & Austin, Texas at Mark Motors"
                ogDescription="The used 2015 Mercedes-Benz SLK350 for sale in Boerne & Austin, Texas is the second of three exceptional models in its class - the used 2015 Mercedes-Benz SLK250, SLK350 and SLK55 AMG."
            />
            {/* <section className='common-banner-wrap add-shadow mob-h-240 position-relative'>
                <img src={getImages('new/2024_Mercedes_Benz_GLS_Feat_O.jpg')} alt='2024 Mercedes-Benz GLS side and backview' />
                <div className='cb-pos'>
                    <h1 className='xl-title font-3em text-uppercase mb-3 wow fadeInUp mxw-980 mx-auto' data-wow-duration="1s" data-wow-delay="0.5s">Discover a Used 2024 Mercedes-Benz GLS in Boerne, TX</h1>
                </div>
            </section> */}
            <section className='cm-wrap pt-200'>
                <div className='container'>
                    <div className="widget-paragraph text-start">
                        <h1>2015 Mercedes-Benz SLK350 For Sale In Boerne, Texas at Mark Motors</h1>
                        <p>
                            <span>The used 2015 Mercedes-Benz SLK350 for sale in Boerne, Texas builds upon the excellent base model by enhancing it with even more power and style, including a 302-horsepower V-6 engine, 18-inch wheels and an AMG body that turns heads whenever you pass. With heated seats and AIRSCARF® neck-level heating, the used 2015 Mercedes-Benz SLK350 for sale in Boerne, Texas lets you turn a cool evening into the perfect time for a top-down drive. The used 2015 Mercedes-Benz SLK350 for sale in Boerne, Texas is the second of three exceptional models in its class - the used 2015 Mercedes-Benz SLK250, SLK350 and SLK55 AMG. It is available in a variety of elegant colors including Black, Mars Red, Polar White, Diamond Silver Metallic, Indium Grey Metallic, Iridium Silver Metallic, Lunar Blue Metallic, Obsidian Black Metallic, Palladium Silver Metallic, Steel Grey Metallic, Cardinal Red Metallic, Diamond White Metallic, Graphite Metallic, Mocha Black Metallic, Mystic Blue Metallic, Magno Alanine Grey Matte, and Magno Cashmere White Matte. Test drive your used 2015 Mercedes-Benz SLK350 for sale in Boerne, Texas at Mark Motors!</span>
                        </p>
                        <h2><span className="s1"><strong>Overview - 2015 Mercedes-Benz SLK350 For Sale Near Boerne, Texas</strong></span></h2>
                        <p>
                            <span>2015 Mercedes-Benz SLK350 for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span><strong>Engine</strong></span>
                            <span>3.5-liter V-6 DOHC</span>
                            <span>302 HP @ 6500 rpm</span>
                            <span>273 @ 3,500 rpm Torque</span>
                            <span>&nbsp;</span>
                            <span><strong>Transmission</strong></span>
                            <span>7-speed automatic w/OD and auto-manual</span>
                            <span>&nbsp;</span>
                            <span><strong>Drive Type</strong></span>
                            <span>Rear-Wheel Drive</span>
                            <span>&nbsp;</span>
                            <span><strong>Efficiency</strong></span>
                            <span>21 city / 29 hwy / 25 combined mpg</span>
                            <span>&nbsp;</span>
                            <span><strong>Wheelbase</strong></span>
                            <span>18-inch Silver Aluminum Rear Wheels</span>
                            <span>&nbsp;</span>
                        </p>
                        <h2><span className="s1"><strong>Engine Features - 2015 Mercedes-Benz SLK350 Dealer In Boerne, Texas</strong></span></h2>
                        <p>
                            <span>2015 Mercedes-Benz SLK350 for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span>Gasoline Direct Injection.</span>
                            <span>Electronic Ignition.</span>
                            <span>Variable Intake Manifold.</span>
                            <span>Aluminum Cylinder Block.</span>
                            <span>Premium Unleaded Recommended Fuel.</span>
                            <span>302-hp @ 6500 rpm.</span>
                            <span>Variable Valve Control.</span>
                            <span>18.5 Fuel Tank Capacity.</span>
                            <span>273 lbs.-ft. @ 3,500 rpm.</span>
                            <span>24 Valves.</span>
                            <span>Longitudinal Engine Orientation.</span>
                            <span>&nbsp;</span>
                            <span>Some features only available in select 2015 Mercedes-Benz SLK350 vehicles for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                        </p>
                        <h2><span className="s1"><strong>Exterior Features - 2015 Mercedes-Benz SLK350 Specials In Boerne, Texas</strong></span></h2>
                        <p>
                            <span>2015 Mercedes-Benz SLK350 for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span>Glass Rear Window.</span>
                            <span>Chrome Tip Exhaust.</span>
                            <span>2 Doors.</span>
                            <span>Body-Colored Door Handles.</span>
                            <span>Available Spoiler.</span>
                            <span>Auto Dimming Left Side-View Mirror.</span>
                            <span>Power Remote Heated Folding Side-View Door Mirrors with Turn Signal Indicator.</span>
                            <span>Galvanized Steel/Aluminum/Composite Body Material.</span>
                            <span>Turn Signal Indicator Mirrors.</span>
                            <span>Power Convertible Roof.</span>
                            <span>Heated Door Mirrors.</span>
                            <span>Available Metallic Paint.</span>
                            <span>Convertible Roof Wind Blocker.</span>
                            <span>Power Door Mirrors.</span>
                            <span>Trunk Rear Cargo.</span>
                            <span>Body-Colored Front and Rear Bumpers.</span>
                            <span>Grille with Chrome Bar.</span>
                            <span>Power Convertible Roof with Lining, Fixed Roll-Over Protection.</span>
                            <span>Retractable Convertible Hard Top.</span>
                            <span>Convertible Hard Top.</span>
                            <span>Available Rear Lip Spoiler.</span>
                            <span>Convertible Roof Lining.</span>
                            <span>&nbsp;</span>
                            <span>Some features only available in select 2015 Mercedes-Benz SLK350 vehicles for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                        </p>
                        <h2><span className="s1"><strong>Interior Features - 2015 Mercedes-Benz SLK350 In Boerne, Texas</strong></span></h2>
                        <p>
                            <span>2015 Mercedes-Benz SLK350 for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span><strong>Convenience</strong></span>
                            <span>Available Distance Pacing Cruise Control.</span>
                            <span>Door Mirror Memory.</span>
                            <span>Passenger Power Folding Mirror.</span>
                            <span>mbrace Emergency Communication System.</span>
                            <span>Available Panorama 1st Row Fixed Glass Sunroof.</span>
                            <span>Sunshade.</span>
                            <span>Available Cruise Control with Distance Pacing.</span>
                            <span>Integrated Key/Remote.</span>
                            <span>Air Filter.</span>
                            <span>Day-Night Rearview Mirror.</span>
                            <span>Glass Sunroof.</span>
                            <span>THERMATIC Manual Air Conditioning.</span>
                            <span>3 Driver and Passenger Memory Seat Settings.</span>
                            <span>Homelink Garage Door Transmitter.</span>
                            <span>Keyfob (all doors) Remote Keyless Entry.</span>
                            <span>Full Floor Console.</span>
                            <span>Driver and Passenger Door Bins.</span>
                            <span>Available Front Dual Zone A/C.</span>
                            <span>Available Navigation System with Voice Activation.</span>
                            <span>Front Cupholder.</span>
                            <span>Available Automatic Temperature Control.</span>
                            <span>Retained Accessory Power.</span>
                            <span>Available Navigation System.</span>
                            <span>REST Residual Heat Recirculation.</span>
                            <span>KEYLESS GO Proximity Key.</span>
                            <span>Cruise Control.</span>
                            <span>Illuminated Driver and Passenger-Side Visor Mirrors.</span>
                            <span>Remote Sunroof/Convertible Roof Controls.</span>
                            <span>Sunroof/Convertible Roof FOB Controls.</span>
                            <span>3 Memory Settings.</span>
                            <span>Steering Wheel Memory.</span>
                            <span>Front Lighter Element(s) Location.</span>
                            <span>1st Row Fixed Glass Sunroof.</span>
                            <span>Illuminated Entry.</span>
                            <span>Available THERMOTRONIC Automatic Dual-Zone Front Air Conditioning.</span>
                            <span>Overhead Console.</span>
                            <span>Ashtray.</span>
                            <span>Mini Overhead Console with Storage.</span>
                            <span>Air Conditioning.</span>
                            <span>1-Touch Up/Down.</span>
                            <span>Sports Steering Wheel with Power Tilting, Power Telescoping, Auto Tilt-Away.</span>
                            <span>Keyfob Trunk/Hatch/Door Release.</span>
                            <span>Remote Keyless Entry.</span>
                            <span>Driver’s Footrest.</span>
                            <span>Valet Function.</span>
                            <span>Auto-Locking Doors.</span>
                            <span>Available Electrochromic Sunshade.</span>
                            <span>1 12V DC Power Outlet.</span>
                            <span>Power Windows.</span>
                            <span>Auto-Dimming Rearview Mirror.</span>
                            <span>Memory Seats.</span>
                            <span>Manual Sunshade.</span>
                            <span>Front Cupholders.</span>
                            <span>Telescoping Steering Wheel.</span>
                            <span>Full Floor Console with Locking Box.</span>
                            <span>Illuminated Locking Glove Box.</span>
                            <span>Auto Tilt-Away Steering Wheel.</span>
                            <span>Tilt Steering Wheel.</span>
                            <span>&nbsp;</span>
                            <span>2015 Mercedes-Benz SLK350 for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span><strong>Seats and Trim</strong></span>
                            <span>8-Way Power Driver &amp; Passenger Seats.</span>
                            <span>2 Max Seating Capacity.</span>
                            <span>Carpet Cargo Space.</span>
                            <span>Available Full Cloth Headliner.</span>
                            <span>Available Genuine Wood Instrument Panel Insert.</span>
                            <span>Bucket Front Seats.</span>
                            <span>Height Adjustable Driver and Passenger Seats.</span>
                            <span>Power 4-Way Driver and Passenger Lumbar Support.</span>
                            <span>Leather Door Panel Trim.</span>
                            <span>Driver and Passenger Heated-Cushions.</span>
                            <span>Passenger Cushion Tilt.</span>
                            <span>Floor Mats.</span>
                            <span>Tire Mobility Kit.</span>
                            <span>Available Leather/Genuine Wood Steering Whel.</span>
                            <span>Driver Lumbar Support.</span>
                            <span>Available Genuine Wood Instrument Panel Insert, Door Panel Insert, Console Insert.</span>
                            <span>Driver Cushion Tilt.</span>
                            <span>Sport Steering Wheel.</span>
                            <span>Passenger Lumbar Support.</span>
                            <span>Cargo Light.</span>
                            <span>Aluminum and Metal-Look Interior Accents.</span>
                            <span>Front Center Armrest.</span>
                            <span>Available Leather/Genuine Wood Shift Knob.</span>
                            <span>Power Reclining Driver and Passenger Seats.</span>
                            <span>Driver and Passenger Heated-Seatbacks.</span>
                            <span>Power Driver and Passenger Fore/Aft Adjustment.</span>
                            <span>Carpet Floor Covering.</span>
                            <span>Cargo Cover.</span>
                            <span>Leather Upholstery.</span>
                            <span>Leather Front Seat Upholstery.</span>
                            <span>Full Vinyl Headliner.</span>
                            <span>Aluminum Instrument Panel Insert, Door Panel Insert, Console Insert.</span>
                            <span>Leather Steering Wheel.</span>
                            <span>Rigid Cargo Cover.</span>
                            <span>Available Genuine Wood Door Panel Insert.</span>
                            <span>Power Driver and Passenger Cushion Tilt.</span>
                            <span>Available Genuine Wood Console Insert.</span>
                            <span>Front Sport Seats.</span>
                            <span>8-Way Driver and Passenger Seat Adjustments.</span>
                            <span>Leather Shift Knob.</span>
                            <span>Heated Front Seats.</span>
                            <span>Carpet Front Floor Mats.</span>
                            <span>&nbsp;</span>
                            <span>Some features only available in select 2015 Mercedes-Benz SLK350 vehicles for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                        </p>
                        <h2><span className="s1"><strong>Entertainment Features - 2015 Mercedes-Benz SLK350 For Sale In Boerne, Texas</strong></span></h2>
                        <p>
                            <span>&nbsp;</span>
                            <span>2015 Mercedes-Benz SLK350 for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span>Primary Monitor Touchscreen.</span>
                            <span>Digital Signal Processor - LOGIC7.</span>
                            <span>Wireless Phone Connectivity.</span>
                            <span>SiriusXM AM/FM/HD/Satellite with Seek-Scan, Single In-Dash CD Player.</span>
                            <span>Audio Theft Deterrent.</span>
                            <span>Speed-Sensitive Volume.</span>
                            <span>Steering-Wheel Mounted Audio Controls.</span>
                            <span>Window Grid Antenna.</span>
                            <span>Send2Benz Internet Access.</span>
                            <span>1 1st Row LCD Monitor.</span>
                            <span>11 Premium Harman/Kardon Speakers.</span>
                            <span>Radio Data System.</span>
                            <span>Available DVD-Audio.</span>
                            <span>500W Amplifier.</span>
                            <span>Available Voice Activated Radio.</span>
                            <span>Weather Band Radio.</span>
                            <span>MP3 Decoder.</span>
                            <span>&nbsp;</span>
                            <span>Some features only available in select 2015 Mercedes-Benz SLK350 vehicles for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                        </p>
                        <h2><span className="s1"><strong>Lighting &amp; Instrumentation - 2015 Mercedes-Benz SLK350 In Boerne, Texas</strong></span></h2>
                        <p>
                            <span>2015 Mercedes-Benz SLK350 for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span>Low-Fuel Warning.</span>
                            <span>Available Cornering Lights.</span>
                            <span>Available Auto-Leveling Headlights.</span>
                            <span>Fully Automatic Headlights.</span>
                            <span>Bulb-Failure Warning.</span>
                            <span>Systems Monitor.</span>
                            <span>Available Blind Spot Sensor.</span>
                            <span>Low-Coolant Warning.</span>
                            <span>Front and Rear Reverse Sensing System.</span>
                            <span>Front Reading Lights.</span>
                            <span>Light-Tinted Windows.</span>
                            <span>Outside-Temperature Display.</span>
                            <span>Oil-Pressure Warning.</span>
                            <span>Dome Light with Fade.</span>
                            <span>Outside Temperature Display.</span>
                            <span>Available PARKTRONIC Front and Rear Parking Sensors.</span>
                            <span>Variably Intermittent Wipers.</span>
                            <span>Available Analog Clock.</span>
                            <span>Rain Sensing Wipers.</span>
                            <span>Available Auto High-Beam Headlights.</span>
                            <span>Low-Oil-Level Warning.</span>
                            <span>Delay-Off Projector Beam Halogen Headlamps.</span>
                            <span>Water Temp. Gauge.</span>
                            <span>Delay-Off Headlights.</span>
                            <span>Battery Warning.</span>
                            <span>Available Lane Departure.</span>
                            <span>Tire Specific Low-Tire-Pressure Warning.</span>
                            <span>Low-Washer-Fluid Warning.</span>
                            <span>Brake-Fluid Warning.</span>
                            <span>Available Delay-Off Projector Beam Xenon High Intensity Low/High Beam Headlamps.</span>
                            <span>Brake Pad Wear.</span>
                            <span>Rear Fog Lights.</span>
                            <span>Key-In-Ignition Warning.</span>
                            <span>Trip Computer.</span>
                            <span>Available Directionally Adaptive Headlights.</span>
                            <span>Compass.</span>
                            <span>Lights-on Warning.</span>
                            <span>Redundant Digital Speedometer.</span>
                            <span>Variable Instrument Panel Lighting.</span>
                            <span>Trip Odometer.</span>
                            <span>Rear Window Defroster.</span>
                            <span>In-Dash Clock.</span>
                            <span>Tachometer.</span>
                            <span>Light Tinted Windows.</span>
                            <span>Available High Intensity Discharge Headlights.</span>
                            <span>Tire Pressure Sensors.</span>
                            <span>Heated Front Windshield Wiper Jets.</span>
                            <span>&nbsp;</span>
                            <span>&nbsp;</span>
                            <span>Some features only available in select 2015 Mercedes-Benz SLK350 vehicles for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                        </p>
                        <h2><span className="s1"><strong>Dimensions &amp; Capacity - 2015 Mercedes-Benz SLK350 For Sale In Boerne, Texas at Mark Motors</strong></span></h2>
                        <p><span>2015 Mercedes-Benz SLK350 for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span>Wheelbase: 95.7 in.</span>
                            <span>Front Legroom: 42.5 in.</span>
                            <span>Front Headroom: 39.1 in.</span>
                            <span>Maximum Interior Cargo Volume: 10.1 cu. ft.</span>
                            <span>Engine Horsepower: 302-hp @ 6500 rpm.</span>
                            <span>Interior Cargo Volume: 6.4 cu. ft.</span>
                            <span>Passenger Volume: 48.8 cu. ft.</span>
                            <span>Engine Bore x Stroke: 3.7 in. X 3.4 in.</span>
                            <span>Compression Ratio: 12 to 1.</span>
                            <span>Engine Type: V-6.</span>
                            <span>Payload: 673 lbs.</span>
                            <span>Valves: 24.</span>
                            <span>Front Shoulder Room: 52.2 in.</span>
                            <span>Front Tread: 61.4 in.</span>
                            <span>Fuel Economy Highway: 29 mpg.</span>
                            <span>Fuel Economy City: 21 mpg.</span>
                            <span>Engine Torque: 273 lbs.-ft. @ 3,500 rpm.</span>
                            <span>Exterior Body Width: 71.5 in.</span>
                            <span>Drag Coefficient: .30</span>
                            <span>Turning Radius: 17.3 ft.</span>
                            <span>Curb Weight: 3417 lbs.</span>
                            <span>Fuel Tank Capacity: 18.5 gal.</span>
                            <span>Valve Train: DOHC.</span>
                            <span>Engine Displacement: 213 cu. in.</span>
                            <span>Exterior Length: 162.8 in.</span>
                            <span>Exterior Height: 51.2 in.</span>
                            <span>Rear Tread: 61.6 in.</span>
                            <span>&nbsp;</span>
                        </p>
                        <h2><span className="s1"><strong>Uncharted A Course - 2015 Mercedes-Benz SLK350 In Boerne, Texas</strong></span></h2>
                        <p><span>The used 2015 Mercedes-Benz SLK350 for sale in Boerne, Texas at Mark Motors brings you even more than its exceptional base model by adding a more powerful engine that reaches 60-mph in an impressive 5.4 seconds, as well as premium 18-inch wheels, and heated seats with the AIRSCARF® heating system. With several packages and configurations to tailor it perfectly for your wants, the used 2015 Mercedes-Benz SLK350 for sale in Boerne, Texas at Mark Motors sits at the top of its class. Come and visit Mark Motors today and let our team find you the perfect used 2015 Mercedes-Benz SLK350 for sale in Boerne, Texas!</span>
                            <span>Used 2015 Mercedes-Benz SLK350 for sale in Boerne, Texas.</span>
                            <span>Mark Motors proudly serves our customers in Boerne, San Antonio, Fredericksburg, and surrounding areas.</span>
                            <span>See dealer or owner's literature for limited warranty details.</span>
                            <span>&nbsp;</span>
                        </p>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Mercedes2015BenzSlk350ForSaleInBoerneTexas